<template>
	<v-container>
		<div class="customer-ref"></div>
		<div v-if="getClientName !== 'admin' && backButton === '' && this.$store.getters.getNbShipments > 1">
			<v-btn class="export" @click="() => $router.back()">
				<v-icon style="margin: 0 6px 0 0">mdi-arrow-left</v-icon> {{ customerHuReference }}
			</v-btn>
		</div>
		<div v-else-if="getClientName !== 'admin' && backButton === '' && (this.$store.getters.getNbShipments === 1 || !this.$store.getters.getNbShipments )">
			<span class="reference">
				{{customerHuReference}}
			</span>
		</div>
		<v-app-bar
			v-if="getServiceSubpages.length > 0"
			color="white"
			class="subpages"
			height="50"
			flat>
			<div class="links-tabs d-flex align-center">
				<span v-for="(subpage, index) in getServiceSubpages" :key="index">
					<router-link
						v-if="subpage"
						:to="{ path: $route.path, query: { ...$route.query, tab: subpage.url }}"
						replace
						v-slot="{ href, route, navigate }"
					>
						<a :href="href" @click="navigate" :class="route.query.tab === $route.query.tab ? 'router-link-exact-active' : ''">
							<span class="subpage" v-if="subpage.translated">{{  $t(`${subpage.name}`) }} <sup v-if="subpage.number !== null"> {{ subpage.number }}</sup></span>
							<span class="subpage" v-else>{{ subpage.name }}<sup v-if="subpage.number !== null"> {{ subpage.number }}</sup></span>
						</a>
					</router-link>
				</span>
			</div>
		</v-app-bar>
	</v-container>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
	props: ['customerHuReference', 'backButton'],
	computed: {
		...mapGetters(['getClientName', 'getClientId', 'getServiceSubpages'])
	}
};
</script>

<style lang="scss">

@import "@/scss/_colors.scss";
.id-tnt {
	margin-left: 12px;
}
.subpages .v-toolbar__content {
	justify-content: center;
}
.links-tabs {
	a {
		display: block;
		margin-top: 20px;
		text-decoration: none;
		color: #575756;
		font-size: .1.1em;
		font-weight: 700;
		padding: 7.5px 18px;
		border-radius: 5px;
		sup {
			color: $primary;
		}
		&.router-link-exact-active {
			background-color: $primary !important;
			color: #fff !important;
			sup {
				color: #fff;
			}
		}
	}
}
.customer-ref {
	margin:  5px 0px;
	font-weight: bold;
}
.reference {
	font-weight: bold;
	color: #3200E6;
}
@media screen and (max-width: 600px) {
	.subpages {
		height: auto !important;
		> div {
			height: auto !important;
		}
		.links-tabs {
			flex-direction: column;
		}
	}
}
</style>
